module.exports = __webpack_public_path__ + "uy.svg?2ac18c6e7d7cbee175d28bf5b7e764ad";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/uy.svg
// module id = 1676
// module chunks = 0